import React, {useState} from "react";
import {Typography} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

const values = ["DOLLARS", "QUANTITY"];

export default function QtyBasisDropDown({top, dispatchTop}) {
    return (
        <TextField
            select
            value={top.quantityBasis !== "none" ? top.quantityBasis : ""}
            variant="outlined"
            size="small"
            style={{backgroundColor: "white", width: "100%"}}
            onChange={ev => dispatchTop({quantityBasis: ev.target.value})}
            label={<Typography style={{fontSize: 10}}>Qty basis</Typography>}
        >
            {values.map((option) => (
                <MenuItem key={option} value={option}>
                    <Typography style={{fontSize: 9}}>{option}</Typography>
                </MenuItem>
            ))}
        </TextField>
    );
}